<template>
  <div class="d-flex flex-column justify-content-between">
    <div class="d-flex flex-column">
      <b-row>
        <b-col>
          <b-card class="card-border-radius common-shadow noborder" body-class="body-landing">
            <div class="">
              <b-row class="mt-1 pt-1 px-2" style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                ">
                <span style="vertical-align: baseline"
                  class="text-kanit-color-grey font-kanit-regular-14">เอกสารระหว่างเดือน</span>
                <b style="vertical-align: baseline" class="text-kanit-color-black font-kanit-bold-16">{{
                  convertPeriodDate(userData.periodStatementKtb) }}</b>
              </b-row>
              <b-row class="pt-2 justify-content-md-center text-center" v-if="
                documentType.example_doc !== null &&
                documentType.example_doc.length > 0
              ">
                <b-col>
                  <span @click="showExampleDoc()"
                    class="span-aherf-text font-kanit-regular-14">ดูข้อแนะนำและตัวอย่างเอกสาร</span>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <div class="pt-3">
        <b-row>
          <b-col>
            <h3 class="font-kanit-bold-18 text-kanit-color-black">
              อัปโหลด Statement
            </h3>
          </b-col>
          <div class="w-100"></div>
          <b-col>
            <p class="text-kanit-color-grey font-kanit-regular-14">
              เลือก Statement ของบัญชีที่มีรายการเคลื่อนไหวสม่ำเสมอ
              หรือใช้เป็นบัญชีหลัก เพื่อเพิ่มโอกาสในการพิจารณาสินเชื่อ
              สามารถเลือกได้มากกว่า 1 วิธี
            </p>
          </b-col>
        </b-row>
      </div>

      <!-- Choose option -->
      <b-card v-for="(item, key) in updateType" :key="key" class="card-border-radius common-shadow noborder mt-3"
        :class="(documentType.state === 'error' || statusSizeOver) && item.type == 2
          ? 'card-danger'
          : documentType.state === 'warning' && item.type == 2
            ? 'card-warning'
            : ''
          " style="cursor: pointer; line-height: 1.25" :style="(lstAccountEmptyStatus && item.type == 1) || !item.active_flag
            ? 'background-color: #E5E7EB; border: 0px; box-shadow: 0px 2px 6px 0px #D1D5DB4D; cursor: not-allowed;'
            : ''
            " @click="item.goto && item.active_flag ? item.goto() : () => { }">
        <b-row class="card-layout-padding-container">
          <b-col class="card-layout-padding-content">
            <b-row class="title card-layout-padding-object" align-self="center">
              <b-col col style="padding: 0">
                <span class="font-kanit-bold-16 text-kanit-color-black" style="vertical-align: sub" :style="(lstAccountEmptyStatus && item.type == 1) ||
                  !item.active_flag
                  ? 'color: var(--color-text-hide-primary) !important;'
                  : ''
                  ">
                  {{ item.uploads_message }}
                </span>
              </b-col>
              <b-col cols="1" class="px-0" v-b-toggle="'my-collapse-' + item.type">
                <b-icon icon="chevron-up" font-scale="1.3" style="color: var(--color-primary); margin-bottom: 25%"
                  :class="item.type == 1
                    ? item.visible && !lstAccountEmptyStatus
                      ? 'chevron-up'
                      : 'chevron-down'
                    : item.goto
                      ? 'chevron-right'
                      : item.visible
                        ? 'chevron-up'
                        : 'chevron-down'
                    " :style="(lstAccountEmptyStatus && item.type == 1) ||
                      !item.active_flag
                      ? 'color: var(--color-text-hide-primary) !important;'
                      : ''
                      " />
              </b-col>
            </b-row>
            <template v-if="
              dStatementSelected &&
              item.type == 3 &&
              item.active_message !== null
            ">
              <b-row align-self="center" class="card-layout-padding-object pt-1">
                <h4 class="font-kanit-bold-14 text-kanit-color-orange-light">
                  {{ item.active_message }}
                </h4>
              </b-row>
            </template>
            <template v-if="
              item.uploads_desc_message && item.uploads_desc_message != null
            ">
              <b-row align-self="center" class="card-layout-padding-object pt-1">
                <h4 class="font-kanit-regular-14 text-kanit-color-grey" :style="(lstAccountEmptyStatus && item.type == 1) ||
                  !item.active_flag
                  ? 'color: var(--color-text-hide-primary) !important;'
                  : ''
                  ">
                  {{ item.uploads_desc_message }}
                </h4>
              </b-row>
            </template>
            <template v-if="item.type == 1">
              <template v-if="lstAccountEmptyStatus">
                <b-row class="card-layout-padding-object">
                  <hr style="height: 1px; width: 100%; background-color: #e5e7eb" />
                </b-row>
                <b-row class="card-layout-padding-object">
                  <h5 class="font-kanit-regular-14 text-revamp-color-seccond">
                    ไม่มีบัญชีที่สามารถใช้ได้ กรุณาอัปโหลด Statement
                    ด้วยวิธีการอื่น
                  </h5>
                </b-row>
              </template>
              <template v-else>
                <template>
                  <b-collapse :id="'my-collapse-' + item.type" v-model="item.visible">
                    <b-row align-self="center" style="margin-top: 10px" class="card-layout-padding-object">
                      <ComponentMiniListAccount :accountSelected="objAcc" :callback="callbackEvent"
                        :state="documentType.state" />
                    </b-row>
                    <b-row class="mt-2 card-layout-padding-object">
                      <h5 class="font-kanit-regular-12 text-kanit-color-grey">
                        {{ item.footer }}
                      </h5>
                    </b-row>
                  </b-collapse>
                </template>
              </template>
            </template>

            <template v-if="item.type == 2">
              <template>
                <b-row align-self="center" class="card-layout-padding-object">
                  <h4 class="font-kanit-regular-14" :class="statusSizeOver
                    ? 'text-kanit-color-danger'
                    : 'text-kanit-color-grey'
                    ">
                    {{ statusSizeOver ? "ขนาดเกินมา" : "เหลือพื้นที่" }}
                    <span :class="statusSizeOver ? '' : 'text-revamp-color-size-black'
                      ">
                      {{
                        getFileSizeAndType(
                          Number(
                            documentType.filesReal.length > 0
                              ? Math.abs(documentType.totalFileSize)
                              : Number(documentType.max_size) * (1000 * 1000)
                          )
                        )
                      }}
                    </span>
                  </h4>
                </b-row>
              </template>
              <template v-if="documentType.state === 'error'">
                <b-row align-self="center" class="card-layout-padding-object pt-1">
                  <h4 class="font-kanit-bold-14 text-kanit-color-danger">
                    อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
                  </h4>
                </b-row>
              </template>
              <template v-else-if="documentType.state === 'warning'">
                <b-row align-self="center" class="card-layout-padding-object pt-1">
                  <h4 class="font-kanit-bold-14 text-kanit-color-orange">
                    อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง<br />หรือข้ามการอัปโหลดเอกสารนี้
                  </h4>
                </b-row>
              </template>
              <b-collapse :id="'my-collapse-' + item.type" v-model="item.visible" style="width: 100%">
                <b-row class="card-layout-padding-object">
                  <hr style="height: 1px; width: 100%; background-color: #e5e7eb" />
                </b-row>
                <b-row class="card-layout-padding-object pt-2">
                  <b-col style="width: 100%; padding: 0">
                    <ComponentMiniUpload :documentTypeObj="documentType" :viewRecommend="false"
                      :callback="callbackSetStateDocumentType" :onReceiveNativeCommand="onReceiveNativeCommand"
                      :uploadType="'mainAccount'" />
                  </b-col>
                </b-row>
              </b-collapse>
            </template>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <!-- Button -->
    <div style="padding-top: 32px; padding-bottom: 20px">
      <b-row v-if="!checkDocIsSuccess()">
        <b-col align-self="center">
          <button @click="goback()" :disabled="checkRequire()" class="btn btn-block btn-submit-landing-page"
            style="letter-spacing: 0px">
            {{ "บันทึก" }}
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { getFileSize } from "@/utils/FileSize.js";
import { exampleDoc } from "@/utils/popup/ExampleDoc.js";
import { Warning } from "@/utils/popup/Warning.js";
export default {
  components: {
    ComponentMiniListAccount: () =>
      import("@/components/TemplateNewScreen/CommonMiniListAccount.vue"),
    ComponentMiniUpload: () =>
      import("@/components/TemplateNewScreen/CommonMiniUpload.vue"),
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  data() {
    return {
      updateType: [],
      objAcc: [],
      documentType: {},
      dStatementSelected: false,
      currentAccount: [],
      currentFilesReal: [],
      currentDStatementSelected: false,
      lstAccountEmptyStatus: false,
      lstAccountOneStatus: false,
      visibleListAccount: true,
      statusSizeOver: false,
      grpId: this.$route.params.grpId,
    };
  },
  created() {
    this.$event.$on("onGoBackCallback", () => this.goToPreviousPage());
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      // console.error(err);
    }
    this.initUpdateType();
  },
  mounted() {
    let currentMenu = {
      pageCode: "CommonStatementDocument",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      ).grp_name,
      previousPage: this.userData.routerPath.landingRevamp,
    };
    this.$event.$emit("update_current_menu", currentMenu);
  },
  beforeUpdate() {
    // console.log("start every time")
    const docTypeState = this.getDocType().state;
    if (
      (docTypeState === "error" || docTypeState === "warning") &&
      this.documentType.filesReal.length === 0
    ) {
      this.documentType.state = docTypeState;
    }
  },
  beforeDestroy() {
    this.$event.$off("onGoBackCallback");
  },
  methods: {
    getFileSizeAndType(fSize) {
      return getFileSize(fSize);
    },
    initUpdateType() {
      this.updateType = [];
      this.updateType.push({
        type: 1,
        uploads_message: "วิธี 1 : เลือกจากบัญชีกรุงไทย",
        uploads_desc_message: "สะดวก รวดเร็ว ไม่ต้องอัปโหลดเอกสารเอง",
        active_flag: true,
        footer: "แสดงเฉพาะบัญชีที่ตรงเงื่อนไขที่ธนาคารกำหนด",
        visible: true,
      });
      this.updateType.push({
        type: 2,
        uploads_message: "วิธี 2 : อัปโหลดด้วยตนเอง",
        active_flag: true,
        visible: true,
      });

      if (this.userData.dStatementSelected != null) {
        this.dStatementSelected = this.userData.dStatementSelected;
      }

      if (this.userData.currentDStatementSelected != null) {
        this.currentDStatementSelected =
          this.userData.currentDStatementSelected;
      }

      if (
        this.userData.accountSelected != null &&
        this.userData.accountSelected.length > 0
      ) {
        this.objAcc = [...this.userData.accountSelected];
        this.currentAccount = [...this.userData.accountSelected];
      }

      this.documentType = {
        ...this.userData.documentType.find(
          (v) =>
            v.doc_code ==
            this.userData.document_group_type.find(
              (item) =>
                item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
            ).lst_doc_id[0]
        ),
      };
      this.currentFilesReal = [...this.documentType.filesReal];
      this.$store.dispatch("setUserData", this.userData);
    },
    convertPeriodDate(data) {
      var split = data.split(" ");
      return split[1] + " 25" + split[2] + " - " + split[5] + " 25" + split[6];
    },
    saveLocalData() {
      let dataMatchDocCode = this.userData.documentType.find(
        (item) => item.doc_code === this.documentType.doc_code
      );
      this.userData.accountSelected = this.objAcc;
      dataMatchDocCode.filesReal = this.documentType.filesReal;
      dataMatchDocCode.totalFileSize = this.documentType.totalFileSize;
      if (
        dataMatchDocCode.state === "warning" ||
        dataMatchDocCode.state === "error" ||
        this.objAcc.length > 0
      ) {
        this.documentType.state = "attachfile";
        dataMatchDocCode.state = "attachfile";
      } else {
        if (
          this.objAcc.length === 0 &&
          this.documentType.filesReal.length === 0
        ) {
          dataMatchDocCode.state = "wait";
        } else {
          dataMatchDocCode.state = this.documentType.state;
        }
      }
      this.$store.dispatch("setUserData", this.userData);
      return true;
    },
    goback() {
      if (this.saveLocalData()) {
        this.routeBack();
      }
    },
    openDStatement() {
      this.$router.push({
        name: this.userData.routerPath.dStatement,
        param: {
          checkDocIsSuccess: this.checkDocIsSuccess(),
        },
      });
    },
    maskAccountNo(value) {
      return (
        "XXX" +
        "-" +
        "X" +
        "-XX" +
        value.substring(6, 9) +
        "-" +
        value.substring(9, 10)
      );
    },
    checkDocIsSuccess() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let docType = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      );
      return docType.state != undefined && docType.state == "success";
    },
    getSizeUpload() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let sizeDoc = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      ).filesReal?.length;
      if (sizeDoc > 0) {
        if (this.checkDocIsSuccess()) {
          return "อัปโหลดสำเร็จ " + sizeDoc + " ไฟล์";
        } else {
          return "รออัปโหลด " + sizeDoc + " ไฟล์";
        }
      }
      return "";
    },
    checkChangeStatementTypeI() {
      const changeFilter = this.objAcc.filter(
        (item) => !this.currentAccount.some((x) => x === item)
      );
      return (
        changeFilter.length === 0 &&
        this.currentAccount.length === this.objAcc.length
      );
    },
    checkChangeStatementTypeII() {
      const changeFilter = this.documentType.filesReal.filter(
        (item) =>
          !this.currentFilesReal.some(
            (x) => x.filename === item.filename && x.filesize === item.filesize
          )
      );
      return (
        changeFilter.length === 0 &&
        this.currentFilesReal.length === this.documentType.filesReal.length
      );
    },
    checkChangeStatementTypeIII() {
      return this.currentDStatementSelected === this.dStatementSelected;
    },
    isChange() {
      if (this.documentType.state == "warning") {
        if (this.objAcc.length > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return (
          (this.checkChangeStatementTypeI() &&
            this.checkChangeStatementTypeII() &&
            this.checkChangeStatementTypeIII()) ||
          this.statusSizeOver ||
          this.documentType.state === "error"
        );
      }
    },
    checkRequire() {
      if (this.checkDocIsSuccess()) {
        return false;
      }
      if (
        this.documentType.filesReal.some(
          (item) =>
            item.fileHavePassword == true && item.fileCheckassword != true
        )
      ) {
        return true;
      }
      let check = false;
      if (this.isChange()) {
        check = true;
      }

      if (
        !this.checkChangeStatementTypeI() &&
        this.documentType.state === "error"
      ) {
        this.documentType.state = "warning";
        this.saveState(this.documentType);
      }
      return check;
    },
    getHistoryUploads() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    showDstatementMessage() {
      return this.userData.showDStatementErrorMsg;
    },
    calMarginTop() {
      var h = window.innerHeight;
      let defaultVal = 27;
      if (h < 800) defaultVal = defaultVal - 25;
      if (this.dStatementSelected) {
        defaultVal = defaultVal - 9;
      }
      if (this.getSizeUpload() != "") {
        defaultVal = defaultVal - 2;
      }
      if (this.objAcc.length != 0) {
        defaultVal = defaultVal - 10 * this.objAcc.length;
      }
      if (defaultVal < 0) return 0;
      return defaultVal;
    },
    callbackEvent(event, f) {
      switch (event) {
        case "list-account-empty":
          this.lstAccountEmptyStatus = f();
          break;
        case "list-account-one":
          this.lstAccountOneStatus = f();
          break;
        case "save-state-upload":
          this.saveState(f());
          break;
      }
    },
    saveState(obj) {
      if (obj) {
        let dataMatchDocCode = this.userData.documentType.find(
          (item) => item.doc_code === obj.doc_code
        );
        dataMatchDocCode.state = obj.state;
        this.$store.dispatch("setUserData", this.userData);
      }
    },
    goToPreviousPage() {
      if (this.isChange()) {
        this.routeBack();
      } else {
        this.alertUnSaveState();
      }
    },
    alertUnSaveState() {
      if (this.documentType.state === "warning") {
        this.routeBack();
      } else {
        Warning(
          {
            title: "ยืนยันการออกจากหน้านี้?",
            message: "ข้อมูลของคุณจะไม่ถูกบันทึก",
            confirmButtonText: "ออกจากหน้านี้",
            cancelButtonText: "ยกเลิก",
            confirmCallBack: () => {
              if (this.dStatementSelected !== this.currentDStatementSelected) {
                this.dStatementSelected = this.currentDStatementSelected;
                this.userData.currentDStatementSelected =
                  this.currentDStatementSelected;
                this.userData.dStatementSelected =
                  this.currentDStatementSelected;
                this.$store.dispatch("setUserData", this.userData);
              }
              this.routeBack();
            },
          },
          this.$swal
        );
      }
    },
    showExampleDoc() {
      exampleDoc(this.documentType.example_doc, this.$swal);
    },
    callbackSetStateDocumentType(docType) {
      try {
        const totalFileSize =
          Number(docType.max_size * (1000 * 1000)) -
          Number(docType.filesRealSize);
        this.documentType.totalFileSize = totalFileSize;
        if (totalFileSize < 0) {
          this.statusSizeOver = true;
        } else {
          this.statusSizeOver = false;
        }
        this.$forceUpdate();
      } catch (er) {
        console.error(er);
      }
    },
    routeBack() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    getDocType() {
      return this.userData.documentType.find(
        (v) =>
          v.doc_code ==
          this.userData.document_group_type.find(
            (item) =>
              item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
          ).lst_doc_id[0]
      );
    },
    onReceiveNativeCommand(doc_code) {
      window["onReceiveNativeCommand"] = (commandName, payload) => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        console.log("commandName: ", commandName, "  value: ", payload);
        if (commandName == "openCamera") {
          if (isAndroid) {
            document.getElementById("fileCamera_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        } else if (commandName == "openGallery") {
          if (isAndroid) {
            document.getElementById("fileBrowseImage_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        }
      };
      return true;
    },
  },
};
</script>

<style scoped>
.upload-type>.title {
  color: #000000;
}

.upload-type>.footer>button {
  color: #00a3e4;
  background-color: white;
  border-color: #00a3e4;
  font-size: 0.75rem;
}

.upload-type>.body,
.text-grey {
  color: #8e94a4;
}

.text-wait-upload {
  color: rgb(236, 146, 14);
}

.text-upload {
  color: rgb(99, 190, 0);
}

.text-upload-error {
  color: rgb(219, 0, 0);
}

.card-disable {
  color: rgb(138, 159, 171) !important;
  cursor: not-allowed !important;
  background-color: rgb(234, 240, 245) !important;
  border-radius: 15px !important;
}

.recommend-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0px;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  color: rgba(0, 166, 230, 1);
}
</style>
